export const SERVICE_DATA = [
  {
    id: 1,
    skillName: "React Native",
    description: "Hybrid mobile app development using react native technology.",
    iconName: "react-native.webp"
  },
  {
    id: 2,
    skillName: "Node JS",
    description: "Build scalable and secure backend using Node js.",
    iconName: "nodeJs.webp"
  },
  {
    id: 3,
    skillName: "React",
    description: "SaaS based web application development using react js technology.",
    iconName: "react-native.webp"
  },
  {
    id: 4,
    skillName: "Stabilization and Bug Fixing",
    description: "Improving stability and fixing issues in existing apps",
    iconName: "bug.webp"
  }
];
